<template>
    <div class="body">
        <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
                <div class="medical-list">
                    <div class="search">
                    <friendlySearch
                    :search="search"
                    :reset="reset"
                    :numTotal="numTotal"
                    ></friendlySearch>
                    </div>
                    <friendlyLinklist
                    :header-cell-style="{ 
                    background:'#000',color:'#fff'}"
                    :tableHeader="this.friendlylogic.listHeader()"
                    :tableData="friendlyLinkList"
                    :page="this.friendlylogic.searchObj.page"
                    :row-class-name="tableRowClassName"
                    ></friendlyLinklist>
                    <pager
                    :page="this.friendlylogic.searchObj.page"
                    :numTotal="numTotal"
                    :handleCurrentChange="handleCurrentChange"
                    >
                    </pager>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import basecom from "@/components/base";
import top from "@/components/top";
import friendlyLinklist from "@/components/listComponents/pagerList";
import pager from "@/components/listComponents/pager.vue";
import friendlySearch from "@/components/searchComponents/friendlySearch.vue";
export default {
    components: {
        basecom,
        friendlyLinklist,
        pager,
        friendlySearch,
        top
    },
    data() {
        return {
            friendlyLinkList: [],
            page: 1,
            numTotal: 0,
        };
    },
    mounted() {
        this.search();
    },
    methods: {
        tableRowClassName({row, rowIndex}) {
            if(rowIndex%2==1){
                return 'warning-row';
            }else{
                return 'success-row';
            }
        },
        handleCurrentChange: function (page = 1) {
            this.friendlylogic.searchObj.page = page;
            this.friendlylogic.getFriendlyList().then((res) => {
                this.friendlyLinkList = res.friendlyLinkList;
                this.numTotal = res.total;
            });
        },
        reset() {
            window.location.reload()
        },
        search() {
            this.handleCurrentChange();
        },
    },
    };
</script>